import { Button as ANTButton } from "antd"
import React from "react"
import { connect } from "react-redux"
import { setChatSpaceName } from "../../redux/actionCreators/chatData"
import { withRouter } from "react-router-dom"
import getSillyWord from "../../utils/getSillyWord"
import { EditFilled } from "@ant-design/icons"
import "./SpaceModel.scss"
import {
  SUGGEST_NAME,
  SAVE_BUTTON,
  GENERATE_OR_CHOOSE,
  CHAT_SPACE_PLACEHOLDER,
  SPACE_MODAL_TITLE,
  DEFAULT_SPACE_NAME,
} from "../../constants/messages"
import { CustomModal, Button, Input, TextTag } from "../../atoms"

class SpaceModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = { visible: false, chatSpaceName: props.chatSpaceName }
  }

  componentDidUpdate(prevProps) {
    const { chatSpaceName } = this.props
    if (prevProps.chatSpaceName !== chatSpaceName) {
      this.setState({
        chatSpaceName: chatSpaceName,
      })
    }
  }

  showModal = () => {
    this.setState({
      visible: true,
    })
  }

  handleOk = e => {
    //on saving chat space name
    this.props.setChatSpaceName(this.state.chatSpaceName)
    this.setState({
      visible: false,
    })
  }

  handleChange = e => {
    this.setState({
      chatSpaceName: e.target.value,
    })
  }

  handleCancel = e => {
    this.setState({
      visible: false,
      chatSpaceName: this.props.chatSpaceName,
    })
  }

  generateWord = () => {
    // library to generate a random word
    this.setState({
      chatSpaceName: getSillyWord(),
    })
  }

  render() {
    const { buttonType, buttonText } = this.props

    return (
      <div>
        <ANTButton
          icon={<EditFilled className="hideon-small-edit" />}
          className="hideon-small"
          type={buttonType}
          onClick={this.showModal}
        >
          {buttonText}
        </ANTButton>

        <CustomModal
          title={SPACE_MODAL_TITLE}
          visible={this.state.visible}
          keyboard={false}
          onCancel={this.handleCancel}
          footer={[
            <Button
              key="save"
              onClick={this.handleOk}
              disabled={this.state.chatSpaceName ? false : true}
              className="save-btn"
            >
              {SAVE_BUTTON}
            </Button>,
          ]}
          className="space-name-modal"
        >
          <TextTag className="space-name-text">
            {GENERATE_OR_CHOOSE(
              this.props.chatSpaceName === null
                ? DEFAULT_SPACE_NAME
                : this.props.chatSpaceName
            )}
          </TextTag>
          <div className="generate-space-name">
            <Input
              name="chatSpaceName"
              placeholder={CHAT_SPACE_PLACEHOLDER}
              value={this.state.chatSpaceName}
              onChange={this.handleChange}
              autoComplete="off"
            />

            <Button
              btnType="bordered"
              key="generate"
              onClick={this.generateWord}
            >
              {SUGGEST_NAME}
            </Button>
          </div>
        </CustomModal>
      </div>
    )
  }
}

export default connect(null, { setChatSpaceName })(withRouter(SpaceModal))
